import { render, staticRenderFns } from "./OrderPriceTypeOther.vue?vue&type=template&id=39f4ae4c&scoped=true"
import script from "./OrderPriceTypeOther.vue?vue&type=script&lang=js"
export * from "./OrderPriceTypeOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f4ae4c",
  null
  
)

export default component.exports